import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import ImageContainer from "@shared/components/contents/imageContainer/ImageContainer";
import React from "react";
const PresentationMedia = ({ content }) => {
    const { image, topBadge, bottomBadge } = content || {};
    return (_jsxs(Box, { sx: {
            position: "relative",
            maxWidth: "550px",
            width: "fit-content",
            display: { xs: "none", lg: "block" },
        }, children: [_jsx(Box, { sx: {
                    position: "relative",
                    border: "3px solid #fff",
                    overflow: "hidden",
                    // 506×410 à partir de 1440px, réduit proportionnellement en dessous
                    height: "min(410px, 28.47vw)",
                    width: "min(506px, 35.14vw)",
                }, children: image && (_jsx(ImageContainer, { ratio: "", children: React.cloneElement(image, {
                        disableLazy: true,
                        fetchPriority: "high",
                    }) })) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: 0,
                    transform: "translateY(-50%)",
                    left: 0,
                    p: 1,
                    backgroundColor: "#EAF1FF",
                }, children: _jsx(Typography, { variant: "subtitle2", component: "p", children: topBadge }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    transform: "translateY(50%)",
                    p: 1,
                    backgroundColor: "#0CFFC6",
                }, children: _jsx(Typography, { variant: "subtitle2", component: "p", children: bottomBadge }) })] }));
};
export default PresentationMedia;
